export default __webpack_public_path__ + "static/media/Livingroom2.8c07b9f2.webp";